import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { DashboardService } from 'src/app/rest_services/dashboard.service';
import { NewactionService } from 'src/app/rest_services/newaction.service';
import { UserService } from 'src/app/rest_services/user.service';
import { VisitService } from 'src/app/rest_services/visit.service';
import { history } from '../users/equipe/history';
import { actions } from '../new-visit/visite_data_static';
import { MsSectorService } from 'src/app/rest_services/ms-sector.service';
import { SettingsService } from 'src/app/rest_services/settings.service';
import { RoleService } from 'src/app/rest_services/role.service';
import { SurveyService } from 'src/app/rest_services/msSurveyServices/survey.service';
import { SalesService } from 'src/app/rest_services/sales.service';
declare var NotificationFx:any;
declare var Snap:any;

@Component({
  selector: 'app-visite',
  templateUrl: './visite.component.html',
  styleUrls: ['./visite.component.css']
})
export class VisiteComponent implements OnInit, OnDestroy {
  user: any;
  token:any = '';
  APIToken:any = '';
  newactionRequest:any;
  modifyactionRequest:any;
  modifyactionForm: FormGroup;
  actionEdit:any={};
  actionsTeam:any[]=actions;
  htmlYouWantToAdd:any="";
  actionsSelected:any[]=[];
  newactionForm: FormGroup;
  historyActions: any[] = history;
  publicActions:any[]=[];
  customizedActions:any[]=[];

  visit:any;
  actions:any[] = [];
  perso:any;
  set:any;
  detailrapport:any={};
  visitdetail:any={};
  supprimeraction:any;
  allshowing: boolean=false;

  updateActionForm!: FormGroup;
  mobile:boolean=false;medium:boolean=false;

  salesSubscription!:Subscription;

  showmore() {
    this.allshowing=true;
    this.today = this.contacted_persons;
  }
  showless(){
    this.today =this.today.slice(0, 0);
    this.allshowing=false;
  }

  constructor(
    private fb: FormBuilder, 
    private msSurvey : SurveyService,
    private userServiceService:UserService, 
    private roleService: RoleService,
    private settingsService:SettingsService,
    private msSector:MsSectorService, 
    private visitService:VisitService,
    private route: ActivatedRoute, 
    private newactionServiceService:NewactionService, 
    private modifyactionServiceService:NewactionService,
    private dashboardServiceservice:DashboardService,
    private salesService:SalesService
    ) {
    this.modifyactionForm = this.fb.group({
      'action_label': ['', Validators.required],
      // 'action_type' : ['', Validators.required] 
    });  
    this.newactionForm = this.fb.group({
      'action_label': ['', Validators.required],
      // 'action_type' : ['', Validators.required] 
    });
    
    this.updateActionForm = this.fb.group({
      description:['', [Validators.required]],
      status:['', [Validators.required]],
      motif:['', [Validators.required, Validators.minLength(25),Validators.pattern(/^(?!.*\s{2,}).*$/)]]
    });

    this.actionEdit.action_type=1;
   }
  loading_tab_actions:boolean=true;loading_tab_details:boolean=true;loading_actions:boolean=true;
  role:any="";
  connectedUserUuid:any="";
  storedRoles:any;
  id:any;
  from:any;
  originRedirecion:any=null;
  ngOnInit(): void {
    this.getConfig();
    this.getProfileRoles();
    this.token = sessionStorage.getItem("msToken") || localStorage.getItem("msToken");
    if(localStorage.getItem("role")!=undefined) {
      this.role = localStorage.getItem("role");
      this.APIToken = localStorage.getItem("token");
    }else if(sessionStorage.getItem("role")!=undefined){
      this.role = sessionStorage.getItem("role");
      this.APIToken = sessionStorage.getItem("token");
    }
    if(this.APIToken){
      let decodedAPIToken = JSON.parse(window.atob(this.APIToken.split('.')[1]));
      this.connectedUserUuid = decodedAPIToken.userId;
    }

    if (window.screen.width <= 768) { // 768px portrait
      this.mobile = true;
      if (window.screen.width > 668) this.medium = true;
    }else {
      this.mobile = false;
    }
    const id= this.route.snapshot.paramMap.get('cr')

    this.getSurveyStatus(id);
    
    this.id= this.route.snapshot.paramMap.get('cr')
    var fr= window.location.href.split( 'from');
    if(fr[1]!=undefined && fr.length>0){
      var from = fr[1].split(';')[0];
      if(from=="comments"){
        (<any>$('.nav-pills a[href="#conversation"]')).tab('show');
        this.getMessagesVisitTerminated(this.id);
      } else if(from=="actions"){ 
        setTimeout(() => {
         (<any>$('.nav-pills a[href="#actions"]')).tab('show');
        }, 2000); 
      }else if(from=="Ref"){
          (<any>$('.nav-pills a[href="#border-top-detail"]')).tab('show');
          this.originRedirecion = "referentiel";
        }
    }
    if(window.location.href.indexOf("customers") > -1){
      this.from = "customers";
    }

    $(document).ready(function() {
      (<any>$('#actions_ofvisit')).DataTable( {
          "pagingType": "full_numbers",
          "language": {
              "paginate": {
                "first": "<i class='flaticon-left-arrow'></i>",
                "previous": "<i class='flaticon-arrow-left-1'></i>",
                "next": "<i class='flaticon-arrow-right'></i>",
                "last": "<i class='flaticon-right-arrow'></i>",
              },
              "info": "Showing page _PAGE_ of _PAGES_"
          }
      });
    } );
    // this.getTabDetails();
    this.Detail(this.id);
    // this.getMessagesVisitTerminated(id);
    if(this.role =="cmrc"){
      this.TodayPlanning();
      //SHOW NOTIFICATION TO COMMERCIAL TO CREATE NEW VISITS
      var svgshape = document.getElementById( 'notification-corner-expand-shape' )as HTMLElement,
        s = Snap( svgshape?.querySelector( 'svg' ) ),
        path = s.select( 'path' ),
        pathConfig = {
            from : path?.attr( 'd' ),
            to : svgshape?.getAttribute( 'data-path-to' )
        }
        NotificationFx.prototype.options = {
          wrapper : document.body,
          message : 'yo!',
          layout : 'growl',
          effect : 'slide',
          type : 'error',
          ttl : 180000, //TIMEOUT CLOSE NOTIFICATIONS - BY ROU
          // callbacks
          onClose : function() { return false; },
          onOpen : function() { return false; }
        }
    }
  }

  config: any = {
    skypeVisibility: false,
    zipCodeVisibility: false
  };
  getConfig(){
    this.settingsService.getConfig().subscribe(
      (resp: any) => {
        if(resp.code == "45859d1ba9e878f62c51935e3119d7ad"){
          this.config.skypeVisibility = resp.config.skypeVisibility;
          this.config.zipCodeVisibility = resp.config.zipCodeVisibility;
          this.config.survey = resp.config.survey;
        }
      },
      (err: any) => {
        console.log(err);
      }
    );
  }
  loading_survey_answers:boolean = true;
  getSurveyAnswers(){
    this.loading_survey_answers=true;
    const id= this.route.snapshot.paramMap.get('cr')
    const surveyContainer = document.getElementById('surveyQuestions');
    if(surveyContainer)surveyContainer.innerHTML = '';

    this.getCustomerResponses(id);
  }

  getCustomerResponses(visitUuid: any){
    this.msSurvey.getCustomerResponses(visitUuid);
    this.msSurvey.customerResponsesSubject.subscribe(
      ( data: any ) => {
        if(data.status== '200'){
          const survey_answers = data.survey_answers;
          const responderInfo = data.responderInfo; // Récupérer les infos du répondant
          
          this.getCustomerRSByVisitUuid(visitUuid);
          
          // Mettre à jour la méthode generateSurvey pour gérer les infos du répondant
          this.generateSurvey(survey_answers, responderInfo);
          
          this.loading_survey_answers=false;
        }
      },
    )    
  }

  generateSurvey(survey_answers: any, responderInfo: any) {
    var surveyContainer = document.getElementById('surveyQuestions');
    if (surveyContainer) {
      surveyContainer.innerHTML = '';
    }

    // 1. Détecter le type de sondage
    const hasWamQuestions = survey_answers.some((answer: any) => 
      answer.question.includes('Qualité produit') || 
      answer.question.includes('service commercial') ||
      answer.question.includes('service qualité')
    );

    // 2. Si c'est le sondage personnalisé WAM
    if (hasWamQuestions) {
      this.generateWamSurvey(survey_answers, responderInfo, surveyContainer);
    } else {
      // 3. Sinon, utiliser l'affichage standard
      this.generateStandardSurvey(survey_answers, responderInfo, surveyContainer);
    }
  }

  generateWamSurvey(survey_answers: any, responderInfo: any, surveyContainer: HTMLElement | null) {
    if (!surveyContainer) return;

    // Organiser les questions dans l'ordre spécifique
    const questionOrder = [
      { key: 'Qualité produit', section: '1 - Avez-vous des remarques sur nos produits?' },
      { key: 'Contact commercial', section: '2- Quelles sont vos remarques liées au service commercial ?' },
      { key: 'Délai de réponse sur les demandes de prix', section: '2- Quelles sont vos remarques liées au service commercial ?' },
      { key: 'Politique tarifaire', section: '2- Quelles sont vos remarques liées au service commercial ?' },
      { key: 'Délai de livraison', section: '2- Quelles sont vos remarques liées au service commercial ?' },
      { key: 'Qualité de livraison', section: '2- Quelles sont vos remarques liées au service commercial ?' },
      { key: 'Compétitivité concurrentielle', section: '2- Quelles sont vos remarques liées au service commercial ?' },
      { key: 'Disponibilité des documentations', section: '4- Quelles sont vos remarques sur le service qualité ?' },
      { key: 'Traitement des réclamations', section: '4- Quelles sont vos remarques sur le service qualité ?' },
      { key: 'degré de satisfaction général', section: '5- Quel est votre degré de satisfaction général en ce qui concerne notre entreprise ?' }
    ];

    // Filtrer les questions de l'enquête et les suggestions
    const surveyQuestions = survey_answers.filter((answer: any) => 
      answer.qst_type === 'ch' && questionOrder.some(q => answer.question.includes(q.key))
    );

    const suggestionQuestion = survey_answers.find((answer: any) => 
      answer.qst_type === 'fr' && answer.question.includes('suggestions')
    );

    // Créer la structure HTML
    const surveySection = document.createElement('div');
    surveySection.className = "survey-section mb-5";

    const sectionTitle = document.createElement('h4');
    sectionTitle.className = "section-title mb-4";
    sectionTitle.style.color = "#027476";
    sectionTitle.textContent = "Réponses à l'enquête de satisfaction";
    surveySection.appendChild(sectionTitle);

    // Afficher par sections dans l'ordre
    let currentSection = '';
    
    questionOrder.forEach((orderItem, index) => {
      const answer = surveyQuestions.find((a: any) => a.question.includes(orderItem.key));
      
      if (answer) {
        // Ajouter un titre de section si changement
        if (currentSection !== orderItem.section) {
          currentSection = orderItem.section;
          const sectionDiv = document.createElement('div');
          sectionDiv.className = "section-divider mt-4 mb-3";
          
          const sectionTitle = document.createElement('h5');
          sectionTitle.className = "section-subtitle";
          sectionTitle.style.color = "#015687";
          sectionTitle.textContent = currentSection;
          sectionDiv.appendChild(sectionTitle);
          
          surveySection.appendChild(sectionDiv);
        }

        // Créer la ligne de question
        const questionDiv = document.createElement('div');
        questionDiv.className = "row d-flex justify-content-center mb-4";
        
        // Extraire le texte après "➜ " s'il existe
        let questionText = answer.question;
        const arrowIndex = questionText.indexOf('➜');
        if (arrowIndex !== -1) {
          questionText = questionText.substring(arrowIndex + 2).trim();
        }
        
        const questionContent = `
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <strong>${questionText}</strong>
          </div>
        `;
        
        // Affichage de la réponse
        let responseContent = '';
        if (orderItem.key.includes('degré de satisfaction général')) {
          responseContent = `
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <span class="satisfaction-response ${answer.response.toLowerCase().replace(' ', '-')}">
                ${this.getSatisfactionLabel(answer.response)}
              </span>
            </div>
          `;
        } else {
          responseContent = `
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" style="display: flex; align-items: center;">
              <div class="rating-number ${parseInt(answer.response) >= 3 ? 'rating-good' : 'rating-bad'}">
                ${answer.response}
              </div>
              <div class="rating-label ml-2">
                ${this.getRatingLabel(answer.response)}
              </div>
            </div>
          `;
        }
        
        questionDiv.innerHTML = questionContent + responseContent;
        surveySection.appendChild(questionDiv);
      }
    });

    // Ajouter les suggestions si elles existent
    if (suggestionQuestion) {
      const suggestionDiv = document.createElement('div');
      suggestionDiv.className = "row d-flex justify-content-center mb-4";
      suggestionDiv.innerHTML = `
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <strong>6- Vos suggestions :</strong>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <div class="suggestion-box p-3 bg-light rounded">
            <p class="mb-0">${suggestionQuestion.response || 'Aucune suggestion'}</p>
          </div>
        </div>
      `;
      surveySection.appendChild(suggestionDiv);
    }

    surveyContainer.appendChild(surveySection);
    
    // Ajouter les informations du répondant (inchangé)
    this.generateResponderInfo(responderInfo, surveyContainer);
  }

  generateStandardSurvey(survey_answers: any, responderInfo: any, surveyContainer: HTMLElement | null) {
    if (!surveyContainer) return;

    var questionTypeOrder: { [key: string]: number } = { 'st': 1, 'ch': 2, 'fr': 3 };
    
    const surveyQuestions = survey_answers.filter((answer: any) => 
      answer.qst_type === 'ch' || answer.qst_type === 'st' || answer.qst_type === 'fr'
    );
    
    const responderAnswers = survey_answers.filter((answer: any) => 
      answer.qst_type === 'text' && ['Questionnaire rempli par', 'Fonction', 'Date', 'Visa'].includes(answer.question)
    );

    // Trier les questions de l'enquête
    surveyQuestions.sort(function (a: any, b: any) {
      return questionTypeOrder[a.qst_type] - questionTypeOrder[b.qst_type];
    });

    // Section 1: Questions de l'enquête
    if (surveyQuestions.length > 0) {
      const surveySection = document.createElement('div');
      surveySection.className = "survey-section mb-5";
      
      const sectionTitle = document.createElement('h4');
      sectionTitle.className = "section-title mb-4";
      sectionTitle.style.color = "#027476";
      sectionTitle.textContent = "Réponses à l'enquête de satisfaction";
      surveySection.appendChild(sectionTitle);
      
      surveyQuestions.forEach(function (answer:any) {
        var questionDiv = document.createElement('div');
        questionDiv.className = "row d-flex justify-content-center mb-4";
        
        var questionContent = `
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <strong>${answer.question}</strong>
          </div>
        `;
        
        var responseContent;
        if (answer.qst_type === 'ch') {
          responseContent = `
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" style="display: flex; align-items: center;">
              <div class="rating-number ${parseInt(answer.response) >= 3 ? 'rating-good' : 'rating-bad'}">
                ${answer.response}
              </div>
              <div class="rating-label ml-2">
                ${this.getRatingLabel(answer.response)}
              </div>
            </div>
          `;
        } else if (answer.qst_type === 'st') {
          var filledStars = parseInt(answer.response);
          var emptyStars = 5 - filledStars;
          responseContent = `
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" style="display: block;">
              <div class="star-rating">
                ${Array.from({ length: filledStars }, (_, i) => `
                  <i class="flaticon-star-fill text-warning" style="font-size: 20px;"></i>
                `).join('')}
                ${Array.from({ length: emptyStars }, (_, i) => `
                  <i class="flaticon-star-outline" style="font-size: 20px; color: #ccc;"></i>
                `).join('')}
              </div>
            </div>
          `;
        } else if (answer.qst_type === 'fr') {
          responseContent = `
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" style="display: block;">
              <div class="suggestion-box p-3 bg-light rounded">
                <p class="mb-0">${answer.response || 'Aucune suggestion'}</p>
              </div>
            </div>
          `;
        }
        questionDiv.innerHTML = questionContent + responseContent;
        surveySection.appendChild(questionDiv);
      }.bind(this));
      
      surveyContainer.appendChild(surveySection);
    }
    
    // Informations du répondant
    this.generateResponderInfo(responderInfo, surveyContainer);
  }

  // Méthode pour générer les informations du répondant (réutilisable)
  generateResponderInfo(responderInfo: any, surveyContainer: HTMLElement | null) {
    if (!surveyContainer) return;

    if (responderInfo) {
      const responderSection = document.createElement('div');
      responderSection.className = "responder-section mt-5 pt-4 border-top";
      
      const sectionTitle = document.createElement('h4');
      sectionTitle.className = "section-title mb-4";
      sectionTitle.style.color = "#027476";
      sectionTitle.textContent = "Informations du répondant";
      responderSection.appendChild(sectionTitle);
      
      const infoTable = document.createElement('div');
      infoTable.className = "responder-info-table";
      infoTable.style.backgroundColor = "#f8f9fa";
      infoTable.style.padding = "20px";
      infoTable.style.borderRadius = "8px";
      
      const infoHTML = `
        <div class="row mb-3">
          <div class="col-lg-3 col-md-4 col-sm-12">
            <strong>Questionnaire rempli par :</strong>
          </div>
          <div class="col-lg-9 col-md-8 col-sm-12">
            ${responderInfo.filledBy || 'Non renseigné'}
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-lg-3 col-md-4 col-sm-12">
            <strong>Fonction :</strong>
          </div>
          <div class="col-lg-9 col-md-8 col-sm-12">
            ${responderInfo.function || 'Non renseigné'}
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-lg-3 col-md-4 col-sm-12">
            <strong>Date :</strong>
          </div>
          <div class="col-lg-9 col-md-8 col-sm-12">
            ${responderInfo.fillDate || 'Non renseigné'}
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-4 col-sm-12">
            <strong>Visa :</strong>
          </div>
          <div class="col-lg-9 col-md-8 col-sm-12">
            ${responderInfo.visa || 'Non renseigné'}
          </div>
        </div>
      `;
      infoTable.innerHTML = infoHTML;
      
      responderSection.appendChild(infoTable);
      surveyContainer.appendChild(responderSection);
    }
  }

  // Méthodes utilitaires pour les labels
  getRatingLabel(rating: string): string {
    switch (rating) {
      case '4': return 'Très satisfaisant';
      case '3': return 'Satisfaisant';
      case '2': return 'Peu satisfaisant';
      case '1': return 'Insatisfaisant';
      default: return '';
    }
  }

  getSatisfactionLabel(response: string): string {
    switch (response.toLowerCase()) {
      case 'tres-satisfait': return 'Très satisfait';
      case 'satisfait': return 'Satisfait';
      case 'insatisfait': return 'Insatisfait';
      default: return response;
    }
  }
 
  customer_fullName:string = '';

  getCustomerRSByVisitUuid(id:any){
    this.visitService.getCustomerByVisit(id, ['id', 'customer', 'logo']);
    this.visitService.detailSubject.subscribe(
      ( data: any ) => {
        if(data.code =="9ee6b80261f5935fcdc9848ac558b605"){
          this.customer_fullName = data.visit.contact_fullName;
        }
      },
    )  
  }

  surveyStatus!:any;
  surveyStatusDisplay: string = '';
  getSurveyStatus(uuidVisit : any){
    this.msSurvey.getSurveyStatus(uuidVisit);
    this.msSurvey.surveyStatusSubject.subscribe(
      ( data: any ) => {
        if(data.status== '200'){
          this.surveyStatus = data.survey.surveyStatus;
          switch (this.surveyStatus) {
            case 'sent':
              this.surveyStatusDisplay = 'Envoyé';
              break;
            case 'consulted':
              this.surveyStatusDisplay = 'En attente';
              break;
            case 'responded':
              this.surveyStatusDisplay = 'Répondu';
              break;
            default:
              this.surveyStatusDisplay = '----';
              break;
          }
        }
      },
    )    
  }

  rolesSubscription!: Subscription;
  getProfileRoles(){
    var item:any =null;
    if(localStorage.getItem("prf")!=undefined) {
      item = localStorage.getItem("prf");
    }else if(sessionStorage.getItem("prf")!=undefined){
      item = sessionStorage.getItem("prf");
    }
    this.rolesSubscription = this.roleService.getProfileRoles(item).subscribe(
      (resp: any) => {
        if(resp.code == "bf025c4dcce776832c0d50903044d7f5") {
          this.storedRoles = resp.profileRoles;
        }
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  checkRole(roleName: string): Promise<boolean> {
    return new Promise((resolve) => {
      setTimeout(() => {
        const hasRole = this.storedRoles && this.storedRoles.some((role: any) => role.name === roleName);
        resolve(hasRole);
      }, 2000);
    });
  }

  // Function to get the sites for a specific city UUID
    getCitySites(cityUuid: string): string[] {
      const sites = this.visit?.visit_customer_Sites?.filter((site: any) => site.cityUuid === cityUuid);
      return sites.map((site: any) => site.siteName);
    }

    // Function to get the addresses for a specific city UUID
    getCityAddresses(cityUuid: string): string[] {
      const sites = this.visit?.visit_customer_Sites.filter((site: any) => site.cityUuid === cityUuid);
      return sites.map((site: any) => site.siteAddress);
    }

  // getTabActions(){
  //   this.loading_tab_actions=true;
  //   setTimeout(()=>{
  //     this.loading_tab_actions=false;
  //   }, 1000);
  //   // this.getActionsTabActions();
  // }  
  connectedCommercial:any="";
  today:any[]=[];allVisitsday:any []=[];
  TodayPlanning(){
    var globalvar = this;
    this.dashboardServiceservice.getToday();
    this.dashboardServiceservice.todaySubject.subscribe(
      ( data: any ) => {
        if(data.code =="e4b1ffed04086a59b097faa3afbf6197"){
          this.allVisitsday = data.visits;
          if(data.visits.length==0){
            setTimeout( function() {
              // create the notification
              var notification = new NotificationFx({
                  message : '<img src="assets/img/suivitim_img/calendar_white.gif" style="width: 50px;">'+
                  '<b>RAPPEL</b> : <br><p>Bonjour <b>'+globalvar.connectedCommercial+' </b><br> Aucune visite '+
                  'nˊest planifiée par vous pour aujourdˊhui ! <br>On vous invite à planifier de nouvelles visites <br><br>'+
                  '<img src="assets/img/suivitim_img/toright.gif" style="width: 25px;"><a href="planifier">  Planifier mes visite</a></p>',
                  layout : 'attached',
                  effect : 'bouncyflip',
                  type : 'notice', // notice, warning or error
                  onClose : function() {
                  }
              });
              // show the notification
              notification.show();
            }, 1200 );
          }
        }
      })
  }
  // getTabDetails(){
  //   this.loading_tab_details=true;
  //   setTimeout(()=>{
  //     // this.loading_tab_details=false;
  //   }, 2000);
  // }  
  resetForm(){
    this.updateActionForm.reset();
  }
  // getActionsTabActions(){
  //   this.loading_actions=true;
  //   setTimeout(()=>{
  //     // this.loading_actions=false;
  //   }, 1500);
  // }
  removeSelectedAction(list:any[],value:any){
    let index;
    if(value.action==undefined){
      index = list.findIndex(d => d=== value); //find index in your array
      list=this.actionsSelected;
    }else {
      index = list.findIndex(d => d.action=== value.action); //find index in your array
      list=this.actionsTeam;
    }
    list.splice(index, 1);//remove element from array
  }
  actionToEdit(action:any){
    this.actionEdit=action;
    this.newactionForm.setValue({
      action_label: this.actionEdit.action_label,
      action_type: this.actionEdit.action_type,
      //The x attribute should match the name in the API / database and not the name in your class
   });
    
  }
  ActionFormValue:any;action:any;
  newAction(){
    const ActionFormValue = this.newactionForm.value;
    this.action = {
      action :ActionFormValue.action,
      uuid:ActionFormValue.type
    };
    if(this.action.uuid=="perso"){
      this.actionsTeam.push(this.action);
    }
    setTimeout(()=>{
      this.newactionForm.reset();
    }, 1000);
    
  }
  detail_visit_action:any= {};
  getDetailVisit(visit:any){
    this.detail_visit_action = this.historyActions.find(i => i.uuid === visit);
  }
  contacted_persons:any;
  loading_detail:boolean=true;
  Detail(id:any){
    this.visitService.getDetail(id);
    this.visitService.detailSubject.subscribe(
      ( data: any ) => {
        if(data.code =="9ee6b80261f5935fcdc9848ac558b605"){
          this.visit= data.visit;
          this.msSector.getSector(this.token,this.visit.visit_customer_sector).subscribe(
            (sectorLabel: any) => {
              this.visit.visit_customer_sector = sectorLabel.label;
            },
            (error) => {
              console.log(error);
            }
          );
          this.perso= data.visit.actions;
          this.contacted_persons= data.visit.contacted_persons;
          this.today = data.visit.contacted_persons.slice(0, 0);
          this.CustumizedListactions(this.visit.visit_customer_uuid)
          if(data.visit.actions != null && data.visit.actions != undefined)
          this.actions= data.visit.actions.sort((a:any, b:any) => a.action_date - b.action_date);   
          // this.actions= data.actions;
          setTimeout(()=>{
            this.loading_tab_details=false;
            this.loading_detail=false;
            this.loading_actions=false;
            this.loading_tab_actions=false;
          }, 2000);
        }
      },
    )  
  }
  downloadPicture(event:any,visit:any,base:any){
    if(event.target != null){
      var datevisit = JSON.stringify(visit.visit_planned_at).slice(0,11)
      event.target!.setAttribute('href', 'data:image/jpg;base64,' + base);
      event.target!.setAttribute('download', 'visite_' +visit.visit_customer+"_"+visit.visited_by+"_"+datevisit+'.jpg');
    }
  }

  hoveredFile: any = null;

  showImage(file: any) {
      file.base64Image = 'data:image/png;base64,' + file.file;
      this.hoveredFile = file;
  }

  hideImage() {
      this.hoveredFile = null;
  }
    
  CustumizedListactions(id:any){
    this.visitService.getCustumizedactions(id);
    this.visitService.persoSubject.subscribe(
      ( data: any ) => {
        if(data.code =="ea6467a2de74bbe94af13a6ce4943968"){

          this.customizedActions= data.actions;
          this.customizedActions = this.customizedActions.sort((a:any, b:any) => a.action_label.toLowerCase() > b.action_label.toLowerCase() ? 1 : -1);
          this.addOrUpdateLoading = false;
        }
      },
    )  
  }
  addOrUpdateLoading:boolean = false;
  Newaction(){
    this.addOrUpdateLoading = true;
    var formvalues = this.newactionForm.value;
    if(this.newactionForm.valid){
      this.newactionRequest = {
        action_label :formvalues.action_label,
      }
      this.newactionServiceService.newactionRequest = this.newactionRequest;
      this.newactionServiceService.getNewaction();
      this.newactionServiceService.newactionSubject.subscribe(
      ( data: any ) => {
        if(data.code =="58e325bd14a8c619427cc77656e88a60"){
          this.action = {
            action :data.action.action_label,
            uuid:data.action.action_uuid,
          };
          this.actionsSelected.push(this.action.action);
          this.customizedActions.push(data.action);
          this.addOrUpdateLoading = false;
        }
        this.newactionForm.reset();
      },)
    }
  }
  getPublicActions(){
    this.visitService.getPublicActions();
    this.visitService.actionsSubject.subscribe(
      ( data: any ) => {
        if(data.code=="fc2057117571f77a7b4fdde71772ebcd"){
          this.publicActions = data.actions;
          this.publicActions = this.publicActions.sort((a:any, b:any) => a.action_label.toLowerCase() > b.action_label.toLowerCase() ? 1 : -1);
        }
      },
    )  
  }
  actiontype:any;
  Modifyaction(){
    this.actiontype="e183b47cb3af26aadf83cddda0d47453";
    this.addOrUpdateLoading = true;
    var formvalues = this.modifyactionForm.value;
    if(this.modifyactionForm.valid){
      this.modifyactionRequest = {
        action_label :formvalues.action_label,
        action_type:this.actiontype,
        customer:this.visit.visit_customer_uuid
      }
      this.modifyactionServiceService.modifyactionRequest = this.modifyactionRequest;
      this.modifyactionServiceService.getModifyaction(this.actionEdit.action_uuid);
      this.modifyactionServiceService.modifyactionSubject.subscribe(
      ( data: any ) => {  
        if(data.code =="4a7666e56245c35ffed4081a91ae730b"){
          this.action = {
            action :data.action.action_label,
            uuid:data.action.action_uuid,
          };
        }
        var index = this.customizedActions.indexOf(this.actionEdit);
        if (index !== -1) {
          this.CustumizedListactions(this.visit.visit_customer_uuid)
          
         }
         this.modifyactionForm.reset();
      },)
    }
  }
 
  getDetailrapport(history:any , visit:any){
    this.detailrapport = history ;
    this.visitdetail = visit ;
  }
  Deleteaction(id:any){
    this.addOrUpdateLoading = true;
    this.newactionServiceService.getDeleteaction(id);
    this.newactionServiceService.deleteactionSubject.subscribe(
      ( data: any ) => {
        if(data.code=="114c891a387eb63709491247e20afed3"){
          this.CustumizedListactions(this.visit.visit_customer_uuid)
        }this.addOrUpdateLoading = false;
      },
    )
  }
  getsupprimeraction(action:any){
    this.supprimeraction = action;
  }
  getAllCustomizedActions(){
    this.visitService.getAllCustomizedActions();
    this.visitService.customActionsSubject.subscribe(
      ( data: any ) => {
        if(data.code=="fc2057117571f77a7b4fdde71772ebcd"){
          this.customizedActions = data.actions;
          this.customizedActions = this.customizedActions.sort((a:any, b:any) => a.action_label.toLowerCase() > b.action_label.toLowerCase() ? 1 : -1);
        }
      },
    )  
  }
  pdfOrUpdateLoading:boolean = false;
  Pdf(id_visit:any){ 
    this.pdfOrUpdateLoading = true;
    this.dashboardServiceservice.getPdf(id_visit);
    this.dashboardServiceservice.pdfSubject.subscribe(
      ( data: any ) => {
        if(data.code =="f3030809fbd166bcc94653d58a6e6a47"){
          const source = `data:application/pdf;base64,`+data.report;
          const link = document.createElement("a");
          link.href = source;
          link.download = data.report_filename;
          link.click();
          this.pdfOrUpdateLoading = false;

          $("#successSave").show();
                $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                  // $(this).removeClass();
                });
                setTimeout(()=>{
                  $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                    // $(this).removeClass();
                  });
                  $("#successSave").hide();
                }, 5000);
        }else{
          $("#error").show();
                $('.alert-danger').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                  // $(this).removeClass();
                });
                setTimeout(()=>{
                  $('.alert-danger').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                    // $(this).removeClass();
                  });
                  $("#error").hide();
                }, 5000);
              }
      },)
  }
  loading_messages_visit:boolean=false;
  messages:any[]=[];
  getMessagesVisitTerminated(visit:any){
    this.messages = [];
    this.loading_messages_visit=true;
    this.dashboardServiceservice.getMessagesVisit(visit);
    this.dashboardServiceservice.getMessagesVisitSubject.subscribe(
      ( data: any ) => {
        this.loading_messages_visit=false;
        if(data.code=="d80c758c95256db1f67684948800447d") {
          this.messages = data.messagesVisit;
          // this.loading_messages_visit=false;
          setTimeout(() => {  
            $(".chat-messages")[0]?.animate({ scrollBottom: "320px" }, 200)
            var objDiv = $(".chat-messages")[0];
            objDiv.scrollTop = objDiv?.scrollHeight;
           }, 1000); 
        }else {
          this.messages = [];
        }
      },
    )
  }
  sending: boolean = false;
  sendNewMessage(visit:any){
    var message = $('#messageText').val();
    var myImage = null;
    var myavatar = this.messages.find((d:any) => d.sender== "me");
    if(myavatar!=undefined && myavatar!=null){
      myImage = myavatar.sender_avatar;
    }else {
      myImage = null;
    }            
    if(message != null && message != ""){
      this.sending = true;
      var newMessage = {
        message:message,
        sent_at:new Date(),
        sender:"me",
        sender_avatar:myImage,
        important:$("#roundedChk2").is(':checked')
      }
      var requestBody = {
        message:message,
        important:$("#roundedChk2").is(':checked')
      }
      this.dashboardServiceservice.requestResponseVisit = requestBody;
      this.dashboardServiceservice.sendResponseVisit(visit);
      this.dashboardServiceservice.sendResponseVisitSubject.subscribe(
        ( data: any ) => {
          this.loading_messages_visit=false;
          if(data.code=="292d9f0775864378afb843227b9209b5") {
            this.messages.push(newMessage);
            // $(".chat-messages").animate({scrollTop:$(".chat-messages")[0].scrollHeight})
            $(".chat-messages").animate({ scrollTop: $(".chat-messages")[0]?.scrollHeight }, 500)
            $('#messageText').val("");
            $(".chat-messages").animate({ scrollBottom: $(".chat-messages")[0]?.scrollHeight }, 200)
          }
          this.sending = false;
        },)
    }
    
  }
  MarkAsRead(visit:any){
    this.dashboardServiceservice.markAsRead(visit, null);
    this.dashboardServiceservice.markAsReadSubject.subscribe(
      ( data: any ) => {
    })
  } 

  selectedAction:any ={};
  selectAction(action:any){    
    this.selectedAction = null;
    this.selectedAction = this.actions.find((d:any) => d.action == action);      
    this.updateActionForm.patchValue({
      description:this.selectedAction.action_desc?this.selectedAction.action_desc:'---',
      status:this.getStatus(this.selectedAction.action_status),
      motif :this.selectedAction.action_comment?this.selectedAction.action_comment:''
    })
  }

  getStatus(status: string): string {
    switch (status) {
      case 'Non fait':
        return '38515baefec364fd3d5cf3efb177fa79';
      case 'En cours':
        return '35377d896b4b5dfbe7e5cd804a58ecdb';
      case 'Fait':
        return 'done';
    
      default:
        return '';
    }
  }
  getNameOfStatus(status: string):string{
    switch (status) {
      case '38515baefec364fd3d5cf3efb177fa79':
        return 'Non fait';
      case '35377d896b4b5dfbe7e5cd804a58ecdb':
        return 'En cours';
      case 'done':
        return 'Fait';
    
      default:
        return '';
    }
  }

  successUpdateAction:boolean=false;
  failedUpdateAction:boolean=false;
  loaderUpdateAction:boolean=false;
  updateActionStatusSubscription!: Subscription;

  updateActionStatus(){
    this.loaderUpdateAction = true;
    let formValue = this.updateActionForm.value;
    this.updateActionStatusSubscription = this.visitService.updateStatusAction(formValue.status,formValue.motif,this.selectedAction.action,this.visit.visit).subscribe(
      ( data: any ) => {
        if(data.code=="5f116e45b722b38a15b57085f5705011"){
          this.successUpdateAction = true;
          this.failedUpdateAction = false;
          this.selectedAction.action_status = this.getNameOfStatus(formValue.status);
          this.selectedAction.action_comment = this.updateActionForm.get('motif')?.value;
          const i=this.actions.findIndex((d:any) => d.action == this.selectedAction.action);
          if(i) this.actions.splice(i,1,this.selectedAction);
          this.updateActionForm.reset()

          $("#status_action_updated").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          this.loaderUpdateAction=false;
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#status_action_updated").hide();
            $("#updateAction").click();
          }, 8000);
        }else {
          this.loaderUpdateAction=false;
          this.successUpdateAction = false;
          this.failedUpdateAction = true;
          $("#status_action_not_updated").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#status_action_not_updated").hide();
          }, 8000);
        }
      },
      (err: any) => {
        console.log(err);
        this.loaderUpdateAction=false
        
      }
    )  
  }
  getVisitCities(): string {
    if (!this.visit || !this.visit.visit_customer_cities || this.visit.visit_customer_cities.length === 0) {
      return '---';
    }

    return this.visit.visit_customer_cities.map((city:any) => city.name).join(' - ');
  }

  ngOnDestroy(){
    this.updateActionStatusSubscription?.unsubscribe();
  }

  salesData: any[] = [];
  loadingListSales:boolean =false;
  getSalesVisit(){
    this.loadingListSales = true;    
    this.salesSubscription = this.salesService.getSalesOfVisit(this.id).subscribe(
      (data: any) => {    
        this.salesData = data.sales;
        this.loadingListSales = false    
        if(data.code == "cf0e0d96d99d8cd08b9f74c6dd7c1bb8"){          
          this.getTotalHT();
          this.getTotalTTC();
        }       
        this.loadingListSales = false
      },
      (error:any) => {
        console.log(error);
        this.loadingListSales = false  
      }
    );
  }
  getTotalHT(): number {
    return this.salesData
      .filter(sale => !sale.isMonthHeader)
      .reduce((sum, sale) => sum + (sale.totalHt || 0), 0);
  }

  getTotalTTC(): number {
    return this.salesData
      .filter(sale => !sale.isMonthHeader)
      .reduce((sum, sale) => sum + (sale.totalTtc || 0), 0);
  }

  editableVisitStatuses:string[] = ['Créée','Planifiée','En attente de validation'];
  isDescriptionEditable(){
    const isOwnVisit = Boolean(this.connectedUserUuid) && this.visit?.visit_commercial_uuid === this.connectedUserUuid;
    const isCreator = Boolean(this.connectedUserUuid) && this.visit?.visit_created_by_uuid === this.connectedUserUuid;
    const canEdit = this.role === 'cmrc' || (this.role === 'adm' && (isOwnVisit || isCreator));
    return canEdit && this.editableVisitStatuses.indexOf(this.visit?.visit_status) !== -1;
  }
  editDescriptionValue:string = "";
  editDescriptionLoading:boolean = false;
  editDescriptionError:string = "";
  openEditDescription(){
    this.editDescriptionValue = this.visit?.visit_goal || "";
    this.editDescriptionError = "";
  }
  isDescriptionValid(value:any){
    const v = (value || "").trim();
    return v.length >= 3 && /[a-zA-Z0-9À-ÿ]/.test(v);
  }
  saveEditDescription(){
    this.editDescriptionValue = (this.editDescriptionValue || "").trim();
    if(!this.isDescriptionValid(this.editDescriptionValue)){
      this.editDescriptionError = "Veuillez saisir une description valide (au moins 3 caractères).";
      return;
    }
    this.editDescriptionLoading = true;
    this.editDescriptionError = "";
    this.visitService.updateVisitDescription(this.id, this.editDescriptionValue).subscribe(
      (data:any) => {
        this.editDescriptionLoading = false;
        if(data.code == "aec1d7a78c32d8eae4ad5125feeb5378"){
          this.visit.visit_goal = this.editDescriptionValue;
          (<any>$('#editDescriptionModal')).modal('hide');
        } else if(data.code == "f538b204bae55407551398bd93bcdb04"){
          this.editDescriptionError = "Cette visite n'est plus modifiable (démarrée ou décision prise).";
        } else {
          this.editDescriptionError = "La modification n'a pas pu être enregistrée.";
        }
      },
      (error:any) => {
        this.editDescriptionLoading = false;
        this.editDescriptionError = "La modification n'a pas pu être enregistrée.";
      }
    );
  }
}
